module.exports = __webpack_public_path__ + "img/slide-18-1.ca68ed13.jpg";